import $ from 'jquery';

const selectors = {
	form: '#form',
	section: '.form-section',
	navigation: '.form-navigation',
	previousButton: '.form-navigation .previous',
	nextButton: '.form-navigation .next',
	submitButton: '#submitEntryForm',
	pincodeInput: '.myPinCode input',
};

function initPincode() {
	const $inputs = $(selectors.pincodeInput);

	if (!$inputs.length || typeof $inputs.jqueryPincodeAutotab !== 'function') {
		return;
	}

	$inputs.jqueryPincodeAutotab({
		prevElement: null,
		nextElement: null,
		defaultFlow: true,
	});
}

function initMultiStepForm() {
	const $form = $(selectors.form);

	if (!$form.length) {
		return;
	}

	const $sections = $form.find(selectors.section);
	const $previousButton = $(selectors.previousButton);
	const $nextButton = $(selectors.nextButton);
	const $submitButton = $(selectors.submitButton);

	if (!$sections.length) {
		return;
	}

	$sections.each((index, section) => {
		$(section).find(':input').attr('data-parsley-group', `block-${index}`);
	});

	const parsleyForm = $form.parsley();

	function getCurrentIndex() {
		const $currentSection = $sections.filter('.current');
		const index = $sections.index($currentSection);

		return index >= 0 ? index : 0;
	}

	function navigateTo(index) {
		const safeIndex = Math.max(0, Math.min(index, $sections.length - 1));

		$sections
			.removeClass('current')
			.attr('aria-hidden', 'true')
			.eq(safeIndex)
			.addClass('current')
			.attr('aria-hidden', 'false');

		const isFirstSection = safeIndex === 0;
		const isLastSection = safeIndex === $sections.length - 1;

		$previousButton.toggle(!isFirstSection);
		$nextButton.toggle(!isLastSection);
		$submitButton.toggle(isLastSection);
	}

	$previousButton.on('click', (event) => {
		event.preventDefault();

		navigateTo(getCurrentIndex() - 1);
	});

	$nextButton.on('click', (event) => {
		event.preventDefault();

		const currentIndex = getCurrentIndex();

		parsleyForm
			.whenValidate({
				group: `block-${currentIndex}`,
				force: true,
			})
			.done(() => {
				navigateTo(currentIndex + 1);
			});
	});

	$submitButton.on('click', function (event) {
		event.preventDefault();

		const $button = $(this);
		const currentIndex = getCurrentIndex();

		parsleyForm
			.whenValidate({
				group: `block-${currentIndex}`,
				force: true,
			})
			.done(() => {
				$button.prop('disabled', true).text('Insturen...');

				$form.trigger('submit');
			});
	});

	navigateTo(0);
}

export function initForm() {
	initPincode();
	initMultiStepForm();
}
